require('./brokerRiskInformationBox.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RiskBlock = require('./RiskBlock');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_RISK_TYPE_SIX,
    BROKER_RISK_TYPE_SEVEN
} = require('constants/index');

function buildTableRiskValues(minValue, maxValue) {
    const firstIncluded = minValue === 1;
    const lastIncluded = maxValue === 7;

    const rangeSelected = <RiskBlock selected minValue={minValue} maxValue={maxValue}/>
    const rangePreUnselected = !firstIncluded ? <RiskBlock maxValue={minValue - 1}/> : null;
    const rangePostUnselected = !lastIncluded ? <RiskBlock minValue={maxValue + 1} /> : null;

    return (
        <div className="broker-risk-information-box-risk-table__content">
            {rangePreUnselected}
            {rangeSelected}
            {rangePostUnselected}
        </div>
    );
}

function TableRisk({ minValue, maxValue }) {
    const tableOfRisks = buildTableRiskValues(minValue,maxValue);
    const content = (
        <React.Fragment>
            <div className="broker-risk-information-box-type-seven__title broker-risk-information-box-risk-table__title">
                <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_riskTableTitle" />
            </div>
            <div className="broker-risk-information-box-risk-table__row broker-risk-information-box-risk-table__row-values ">
                {tableOfRisks}
            </div>
            <div className="broker-risk-information-box-risk-table__row">
                <div className="broker-risk-information-box-risk-table__column">
                    <div className="broker-risk-information-box-risk-table__text-left">
                        <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_lessRisk" />
                    </div>
                </div>
                <div className="broker-risk-information-box-risk-table__column">
                    <div className="broker-risk-information-box-risk-table__text-right">
                        <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_moreRisk" />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
    return content;
}

TableRisk.propTypes = {
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
}

TableRisk.defaultProps = {
    minValue: 1,
    maxValue: 7,
}

class BrokerRiskInformationBox extends React.Component {
    typeSixView() {
        return (
            <div className="broker-risk-information-box-type-six__row">
                <div className="broker-risk-information-box-type-six__numbers">
                    <span className="broker-risk-information-box-type-six__numbers--left" >6 </span>
                    <span>/ 6</span>
                </div>
                <span className="broker-risk-information-box-type-six__content" >
                    {formatText('broker-productFileRiskIndicatorContent')}
                </span>
            </div>
        );
    }
    buildLiquidityAlert(description) {
        return (
            <div className="broker-risk-information-box-type-seven__alert">
                <i className="icon-candado broker-risk-information-box-type-seven__warning-icon"></i>
                <i className="icon-candado broker-risk-information-box-type-seven__warning-icon"></i>
                <div className="broker-risk-information-box-type-seven__warning-description">
                    {description}
                </div>
            </div>
        );
    }

    buildComplexityAlerts() {
        const titleInvestmentWarrant = formatText('brokerRiskInformationBox-brokerRiskInformationBox_warningTitle');
        return (
            <div className="broker-risk-information-box-type-seven__text broker-risk-information-box-type-seven__footer">
                <OKMessage type="warning" title={titleInvestmentWarrant}>
                    <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_warningDescription"/>
                </OKMessage>
            </div>
        );
    }

    buildLiquidityAlerts() {
        return (
            <div>
                <div className="broker-risk-information-box-type-seven__text broker-risk-information-box-type-seven__title">
                    <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_liquidityAlertTitle"/>
                </div>
                {this.buildLiquidityAlert(<FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_liquidityAlertText1"/>)}
                {this.buildLiquidityAlert(<FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_liquidityAlertText2"/>)}
            </div>

        );
    }

    typeSevenView(descriptionKey, minRiskValue, maxRiskValue, linksURL, hasComplexityAlert, hasLiquidityAlert) {
        const complexityAlerts = hasComplexityAlert ? this.buildComplexityAlerts() : null;
        const liquidityAlerts = hasLiquidityAlert ? this.buildLiquidityAlerts() : null;
        const linksOfComponent = linksURL.length && linksURL.map((link) => {
            const linkName = link.replace(/(^\w+:|^)\/\//, '');
            return (<OKLink key={link} to={link} target="_blank">{linkName}</OKLink>);
        });
        return (
            <ContentBox modifier="complementary" product="wealth">
                <div className="broker-risk-information-box-type-seven__text broker-risk-information-box-type-seven__title">
                    <FormattedText value="brokerRiskInformationBox-brokerRiskInformationBox_title"/>
                </div>
                <div className="broker-risk-information-box-type-seven__text">
                    <FormattedTextWithComponents value={descriptionKey} injectedComponents={linksOfComponent}/>
                </div>
                <div className="broker-risk-information-box-type-seven__text">
                    <TableRisk minValue={minRiskValue} maxValue={maxRiskValue} />
                </div>
                {liquidityAlerts}
                {complexityAlerts}
            </ContentBox>
        );
    }

    render() {
        const { riskType, descriptionKey, minRiskValue, maxRiskValue, hasComplexityAlert, hasLiquidityAlert, links } = this.props;
        let content;
        if (riskType === BROKER_RISK_TYPE_SIX) {
            content = this.typeSixView();
        }
        else {  //in case of BROKER_RISK_TYPE_SEVEN
            content = this.typeSevenView(descriptionKey, minRiskValue, maxRiskValue, links, hasComplexityAlert, hasLiquidityAlert);
        }
        return content;
    }
}

BrokerRiskInformationBox.propTypes = {
    riskType: PropTypes.oneOf([BROKER_RISK_TYPE_SIX, BROKER_RISK_TYPE_SEVEN]).isRequired,
    descriptionKey: PropTypes.string,
    hasComplexityAlert: Boolean,
    hasLiquidityAlert: Boolean,
    links: PropTypes.arrayOf(PropTypes.string),
    minRiskValue: PropTypes.number,
    maxRiskValue: PropTypes.number,
}

BrokerRiskInformationBox.defaultProps = {
    hasComplexityAlert: false,
    hasLiquidityAlert: false,
    links: [],
    minRiskValue: 1,
    maxRiskValue: 7,
};


module.exports = BrokerRiskInformationBox;
